import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@/core/components/line-clamped-tooltip";
import { IPayout } from "@/payouts/payouts";

export const AdvocateCol = (): ColumnDef<IPayout> => ({
  header: "Advocate",
  accessorFn: (row) =>
    row.referral?.advocate_name || row.referral?.advocate_phone_number,
  cell: ({ getValue }) => {
    const nameOrPhone = getValue() as string;
    return <LineClampedTooltip>{nameOrPhone}</LineClampedTooltip>;
  },
});
